// True on a desktop-sized viewport with a mouse: wide enough for a roomy
// bottom bar and a pointer that does not need the menu to keep targets
// apart. There the bar also carries Share screen and Record (Adam,
// 2026-10-02: "put record and share on the main bar with mute, end, etc on
// desktop view"); a phone or a narrow window keeps them in the "..." menu.
// Tracks the query, so resizing a window or docking a tablet moves them.

import { useSyncExternalStore } from "react";

export const DESKTOP_CONTROLS_QUERY = "(min-width: 900px) and (hover: hover) and (pointer: fine)";

function subscribe(onChange: () => void): () => void {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return () => {};
  const query = window.matchMedia(DESKTOP_CONTROLS_QUERY);
  query.addEventListener("change", onChange);
  return () => query.removeEventListener("change", onChange);
}

function snapshot(): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;
  return window.matchMedia(DESKTOP_CONTROLS_QUERY).matches;
}

export function useDesktopControls(): boolean {
  return useSyncExternalStore(subscribe, snapshot, () => false);
}
